<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/missingTrackMonitor";
export default {
  name: "missingTrackMonitor",
  components: {
    cTable
  },
  methods: {
    handleTab(tab) {
      this.tabName = tab;
      this.config["showOverflow"] = tab === "2" ? false : true;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    },
    printFun(obj) {
      this.printData = obj;
    }
  },
  data() {
    return {
      tabList: [
        {
          label: this.$t("未处理"),
          value: "NO"
        },
        {
          label: this.$t("已处理"),
          value: "YES"
        }
      ],
      tabName: "NO",
      methods: {
        ...apis,
        list: p => {
          p.label = this.tabName;
          return apis.list(p);
        }
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "type",
            placeholder() {
              return this.$tz("类型");
            },
            component: "Select",
            options: [
              {
                label: this.$tz("全段"),
                value: 1
              },
              {
                label: this.$tz("清派"),
                value: 2
              },
              {
                label: this.$tz("退件"),
                value: 3
              }
            ],
            optionsFn: "",
            optionsKey: ""
          },
          {
            key: "country",
            placeholder() {
              return this.$tz("国家");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: ""
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "code",
            placeholder() {
              return this.$tz("轨迹代码");
            },
            component: "Select",
            options: [],
            optionsFn: "getTrackerStatus",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("批量,完成"),
              type: "updateMonitor",
              fnName: "updateMonitor",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            updateMonitor() {
              this.$Modal.confirm({
                title: this.$tz("批量,完成"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "updateMonitor",
                    { ids: this.selectAll.map(t => t.id) },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            },
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("运单号"),
          key: "airway_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("国家"),
          key: "country",
          minWidth: 110
        },
        {
          name: () => this.$tz("客户"),
          key: "client",
          minWidth: 110
        },
        {
          name: () => this.$tz("缺失,轨迹"),
          key: "status",
          minWidth: 130
        },
        {
          name: () => this.$tz("记录,时间"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("类型"),
          key: "type",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
